// extracted by mini-css-extract-plugin
export default {"root":"DiagnosticPackageTable_root__Pfn87","cell":"DiagnosticPackageTable_cell__52qfC","cellCenter":"DiagnosticPackageTable_cellCenter__6o6Zu"};